var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Web3Utils from 'web3-utils';
import { CYCLIC_EVENTS } from '../types';
export function getEpochOffsetForEventType(eventType) {
    return Number(eventType);
}
export function computeScheduleFromTerms(engine, terms, from, to) {
    return __awaiter(this, void 0, void 0, function* () {
        // @ts-ignore
        const { maturityDate } = terms;
        const schedule = [];
        // @ts-ignore
        schedule.push(...(yield engine.methods.computeNonCyclicScheduleSegment(terms, from || 0, to || maturityDate).call()));
        if (to || maturityDate) {
            for (const cyclicEvent of CYCLIC_EVENTS) {
                // @ts-ignore
                schedule.push(...(yield engine.methods.computeCyclicScheduleSegment(terms, from || 0, to || maturityDate, cyclicEvent).call()));
            }
        }
        return sortEvents(removeNullEvents(schedule));
    });
}
export function sortEvents(_events) {
    _events.sort((_eventA, _eventB) => {
        const { eventType: eventTypeA, scheduleTime: scheduleTimeA } = decodeEvent(_eventA);
        const { eventType: eventTypeB, scheduleTime: scheduleTimeB } = decodeEvent(_eventB);
        if (Number(scheduleTimeA) === 0) {
            return 1;
        }
        if (Number(scheduleTimeB) === 0) {
            return -1;
        }
        if (Number(scheduleTimeA) > Number(scheduleTimeB)) {
            return 1;
        }
        if (Number(scheduleTimeA) < Number(scheduleTimeB)) {
            return -1;
        }
        if (getEpochOffsetForEventType(eventTypeA) > getEpochOffsetForEventType(eventTypeB)) {
            return 1;
        }
        if (getEpochOffsetForEventType(eventTypeA) < getEpochOffsetForEventType(eventTypeB)) {
            return -1;
        }
        return 0;
    });
    return _events;
}
export function removeNullEvents(eventSchedule) {
    const compactEventSchedule = [];
    for (let event of eventSchedule) {
        if (String(decodeEvent(event).eventType) === '0') {
            continue;
        }
        compactEventSchedule.push(event);
    }
    return compactEventSchedule;
}
export const decodeEvent = (encodedEvent) => ({
    eventType: String(Web3Utils.hexToNumber('0x' + String(encodedEvent).substr(2, 2))),
    scheduleTime: String(Web3Utils.hexToNumber('0x' + String(encodedEvent).substr(10, encodedEvent.length)))
});
export function encodeEvent(eventType, scheduleTime) {
    const eventTypeAsHex = Web3Utils.padLeft(Web3Utils.toHex(eventType), 2);
    const scheduleTimeAsHex = Web3Utils.padLeft(Web3Utils.toHex(scheduleTime), 62);
    return eventTypeAsHex + scheduleTimeAsHex.substr(2, scheduleTimeAsHex.length);
}
export function parseEventSchedule(encodedEventSchedule) {
    return removeNullEvents(encodedEventSchedule).map((encodedEvent) => decodeEvent(encodedEvent));
}
//# sourceMappingURL=Schedule.js.map